<template>
  <div>
    <my_menu2 v-if="menu_show" :page_name="project_name + ' - 短期工花名册'" back_type="close" back_icon="md-close">
    </my_menu2>
    <div style="height: 40px"></div>
    <div class="tabs_div">
      <Tabs v-model="job_status" @on-click="click_tabs">
        <TabPane label="待确认" name="daiqueren"></TabPane>
        <TabPane label="在职" name="zaizhi"></TabPane>
        <TabPane label="已离职" name="lizhi"></TabPane>
      </Tabs>
    </div>
    <div class="options">
      <div class="search_group">
        <Select v-model="search_key" size="small" class="search_select">
          <Option value="name">姓名</Option>
          <Option value="idcard">身份证号</Option>
        </Select>
        <Input clearable size="small" v-model="search_value" class="search_input" style="width:130px"
          :placeholder="search_key == 'name' ? '输入姓名搜索' : '输入身份证号搜索'" @on-enter="search_btn" @on-clear="search_btn" />
        <Button type="primary" size="small" class="search_btn" @click="search_btn">
          <Icon type="ios-search" />
        </Button>
      </div>
      <div>


        <Button v-if="job_status == 'daiqueren'" size="small" type="primary" style="font-size: 13px; margin-right: 10px"
          @click="add_new_staff">
          <Icon type="md-add" /> 添加新员工
        </Button>
        <Button v-if="job_status == 'daiqueren' || job_status == 'lizhi'" size="small" type="primary"
          style="font-size: 13px; margin-right: 10px" @click="to_zaizhi">
          <Icon type="md-add" />转为在职
        </Button>
        <Button v-if="job_status == 'zaizhi' || job_status == 'lizhi'" type="warning" size="small"
          style="font-size: 12px; margin-right: 5px" @click="batch_insured">
          <Icon type="ios-add-circle-outline" />&nbsp;参保险
        </Button>
        <Button v-if="job_status == 'zaizhi' || job_status == 'lizhi'" type="warning" size="small"
          style="font-size: 12px; margin-right: 5px" @click="gongshang_baoan">
          <Icon type="ios-add-circle-outline" />&nbsp;工伤报案
        </Button>

        <Button v-if="job_status == 'zaizhi'" size="small" type="error" style="font-size: 13px" @click="to_lizhi">
          <Icon type="ios-remove-circle-outline" />转为离职
        </Button>
        <Button v-if="job_status == 'zaizhi' || job_status == 'lizhi'" size="small"
          style="font-size: 13px;margin-left:5px" @click="export_roster" :loading="export_roster_loading">
          <Icon type="ios-cloud-download-outline" />导出花名册
        </Button>
        <Button v-if="job_status == 'daiqueren'" size="small" type="error" style="font-size: 13px"
          @click="batch_delete" :loading="batch_delete_loading">
          <Icon type="ios-trash-outline" />删除
        </Button>
      </div>
    </div>
    <div class="table_div">
      <Spin fix v-if="loading"></Spin>

      <Table :height="windowHeight - 160" size="small" stripe :columns="columns" :data="table_data"
        @on-selection-change="select_change">

        <template #name="{ row }">
          <span class="name" @click="click_name(row)">{{ row.name }}</span>
        </template>

        <template #idcard="{ row }">
          <div class="idcard_span_div">
            <span @click="click_idcard_num(row)" title="点击更新身份证" class="idcard_num">{{ row.idcard }}</span>
            <i title="已实名" v-if="row.is_certification == 1" class="iconfont iconrenzheng"></i>
            <i title="未实名" v-else class="iconfont iconweirenzheng" @click="click_update_certification(row)"></i>

            <i v-if="row.idcard_img_status == 1" class="iconfont iconsfz1 sfz_icon1" title="身份证照片已完善"></i>
            <i v-if="row.idcard_img_status == 0" class="iconfont iconsfz1 sfz_icon2" title="身份证照片没有完善"></i>
          </div>
        </template>
        <template #action="{ row }">
          <div>
            <span class="contract_span" @click="click_contract(row)">合同({{ contract_dict[row.idcard] }}/{{
              total_contract_dict[row.idcard]
            }})</span>

            <span @click="click_insurance(row)" class="contract_span2">保险({{ insurance_count_dict[row.idcard] }})</span>
          </div>
        </template>
        <template #bank_card="{ row }">
          <span @click="click_resume_bank_card(row)" class="bank_card1 bank_card_hover"
            v-if="row.resume_bank_default_status == 1">已完善({{ row.resume_bank_card_count }})</span>
          <span @click="click_resume_bank_card(row)" class="bank_card2 bank_card_hover" v-else>未完善</span>
        </template>
        <template #job_name="{ row }">
          <div>
            <span @click="click_job(row)" class="job">{{ row.job_name }}
              <Icon type="ios-create-outline" />
            </span>
          </div>
        </template>
        <template #belong_name="{ row }">
          <div>
            <span @click="click_update_belong(row)" class="job">{{ row.belong_name ? row.belong_name : '无' }}
              <Icon type="ios-create-outline" />
            </span>
          </div>
        </template>
        <template #phone="{ row }">
          <div>
            <span @click="click_update_phone(row)" class="job">{{ row.phone }}
              <Icon type="ios-create-outline" />
            </span>
          </div>
        </template>
        <template #entry_time="{ row }">
          <div>
            <span @click="click_update_entry_time(row)" class="job">{{ row.entry_time }}
              <Icon type="ios-create-outline" />
            </span>
          </div>
        </template>
        <template #dimission_time="{ row }">
          <div>
            <span @click="click_update_disimmion_time(row)" class="job">{{ row.dimission_time }}
              <Icon type="ios-create-outline" />
            </span>
          </div>
        </template>
      </Table>
      <div class="page_div">
        <Page :total="total_count" :page-size="limit" show-sizer @on-change="page_change"
          @on-page-size-change="limit_change" />
      </div>
    </div>

    <Modal width="430" v-model="baoan_show" title="选择要进行的操作" :footer-hide="true">
      <div class="contract_button_div">
        <Button class="" @click="new_gongshang_baoan" style="margin-right: 10px" type="primary">
          <Icon type="ios-add-circle-outline" />
          工伤报案提交
        </Button>
        <Button class="" @click="gongshang_baoan_record">
          项目工伤报案列表(查看、完善数据)</Button>
        <Button class="" @click="gongshang_baoan_jiaocheng" style="margin-top: 10px">
          <Icon type="ios-book" />工伤报案流程学习
        </Button>
      </div>
    </Modal>

    <!-- 更新手机号 -->
    <Modal v-model="update_phone_show" title="更新手机号" :footer-hide="true" width="300">
      <div>
        <Input maxlength="11" v-model="update_phone_value" placeholder="输入11位手机号码" style="width: 200px" />
      </div>
      <div class="update_phone_button">
        <Button type="primary" @click="update_phone">确认更新</Button>
      </div>
    </Modal>

    <Modal v-model="add_show" title="添加新员工（方式任选其一）" :mask-closable="false" :footer-hide="true" width="500">
      <div>
        <Tabs v-model="add_type">
          <TabPane label="手动输入" name="input">
            <div class="input_1">
              <div class="input_div">
                <div class="input_title">姓名：</div>
                <div>
                  <Input maxlength="11" v-model="add_item.name" placeholder="请输入员工真实姓名" style="width: 200px" />
                </div>
              </div>
              <div class="input_div">
                <div class="input_title">手机号：</div>
                <div>
                  <Input maxlength="11" v-model="add_item.phone" placeholder="请输入11位真实手机号" style="width: 200px" />
                </div>
              </div>
              <div class="input_div">
                <div class="input_title">身份证号：</div>
                <div>
                  <Input maxlength="18" v-model="add_item.idcard" placeholder="请输入18位身份证号" style="width: 200px" />
                </div>
              </div>
            </div>
            <div class="input_button_div">
              <Button type="primary" @click="input_add_request">确认添加</Button>
            </div>
            <div class="qrcode_img_title">
              操作说明：填写信息提交后，数据会进入【待确认】
            </div>
          </TabPane>
          <TabPane label="员工扫码添加" name="yuangong_saoma">
            <div class="qrcode_img_div">
              <div ref="qrCodeUrl" class="qrcode_img" alt=""></div>
            </div>
            <div class="qrcode_img_title">
              操作说明：1、保存或打印这个二维码 2、员工微信扫一扫关注公众号
              3、按公众号提示填写信息报名后数据会进入【待确认】
            </div>
          </TabPane>
          <TabPane label="驻厂扫码" name="zhuchang_saoma">
            <div>
              <img style="width: 450px; height: 140px; margin-bottom: 10px"
                src="@/assets/image/interview/fuwuzhongxin.png" alt="" />
            </div>
            <div>
              操作流程：1、员工微信关注公众号，2、进入个人中心
              3、驻厂使用手机APP进行扫描员工码添加，添加后信息进入【待确认】
            </div>
          </TabPane>
          <TabPane label="表格导入" name="excel_import">
            <div>
              <a :href="import_template_url" class="" style="color: #0466dd">
                <Icon type="md-cloud-download" style="margin-right: 5px" />《点击下载导入模板》
              </a>
            </div>
            <div>
              <div style="height: 200px; width: 450px; margin-top: 10px">
                <Upload multiple ref="upload" type="drag" :action="upload_file_url" :on-success="upload_success">
                  <div style="padding: 20px 0">
                    <Icon type="ios-cloud-upload" size="52" style="color: #3399ff"></Icon>
                    <p>点击上传表格XLS文件</p>
                  </div>
                </Upload>
              </div>
            </div>
            <div>
              <div class="input_button_div">
                <Button type="primary" :loading="daoru_loading" @click="import_confirm">确认上传</Button>
              </div>
            </div>
            <div>操作流程：1、下载模板 2、上传导入数据</div>
          </TabPane>
        </Tabs>
      </div>
    </Modal>

    <Modal v-model="to_zaizhi_show" title="操作入职" :mask-closable="false" :footer-hide="true" width="400">
      <div class="entry_date_box">
        <div class="entry_date_title">入职时间</div>
        <DatePicker type="datetime" v-model="entry_date" placeholder="选择入职时间" style="width: 200px" />
      </div>
      <div class="ruzhi_button">
        <Button type="primary" @click="to_zaizhi_request">确认入职</Button>
      </div>
    </Modal>

    <Modal v-model="daoru_error_show" title="导入失败" :mask-closable="false" :footer-hide="true" width="600">
      <div class="daoru_line_div">
        <div v-for="(item, i) in error_list" :key="i" class="daoru_line">
          {{ i + 1 }}、 {{ item.msg }}
        </div>
      </div>
    </Modal>

    <Modal v-model="to_lizhi_show" title="操作离职" :mask-closable="false" :footer-hide="true" width="400">
      <div class="entry_date_box">
        <div class="entry_date_title">离职时间</div>
        <DatePicker type="datetime" v-model="dimission_date" placeholder="选择离职时间" style="width: 200px" />
      </div>
      <div class="ruzhi_button">
        <Button type="primary" @click="to_lizhi_request">确认离职</Button>
      </div>
    </Modal>

    <Modal width="430" v-model="contract_modal_show" title="选择要进行的操作">
      <div class="contract_button_div">
        <Button class="contract_button_class" @click="click_sing_contract(0)">
          <i class="iconfont icongaizhang"></i>
          单个签合同</Button>
        <Button class="contract_button_class" @click="click_sing_contract(1)">
          <i class="iconfont iconqianshu"></i>
          批量签合同</Button>
        <Button class="contract_button_class" @click="click_sing_contract(2)">
          <i class="iconfont iconqianshu"></i>
          上传纸质合同</Button>
      </div>
      <div style="margin-top: 20px">
        <Button class="contract_button_class3" type="primary" @click="click_contract_list()">
          <i class="iconfont iconhetongleibiao"></i>
          合同签署详情</Button>
      </div>
    </Modal>

    <Modal width="300" v-model="insurance_show" title="选择要进行的操作">
      <div>
        <Button class="contract_button_class" @click="click_insurance_list()">
          <i class="iconfont iconhetongleibiao"></i>
          查看参保详情</Button>
      </div>
    </Modal>
    <update_job_name @change="update_job_name_change" ref="update_job_name"></update_job_name>


    <!-- 更新归属人 -->
    <Modal v-model="update_affiliation_show" title="更新归属人" :footer-hide="true" width="600">
      <div class="field_item_box">
        <div class="field_item">
          <div class="field_title">归属人类型：</div>
          <div>
            <Select v-model="update_affiliation_data.belong_type" style="width: 200px" size="small"
              @on-change="belong_type_change">
              <Option v-for="(item, i) in belong_type_list" :value="item.value" :key="item.value">{{ item.label }}
              </Option>
            </Select>
          </div>
        </div>
      </div>
      <div class="field_item_box" v-if="update_affiliation_data.belong_type == 'B01'">
        <div class="field_item">
          <div class="field_title">归属人姓名：</div>
          <Select size="small" filterable clearable placeholder="请搜索或选择用户" v-model="update_affiliation_data.belong_id"
            style="width: 450px">
            <Option v-for="(item, i) in sys_user_list" :value="item.value" :key="item.value">{{ item.label }}</Option>
          </Select>
        </div>
      </div>

      <div v-if="update_affiliation_data.belong_type == 'B02'">
        <div class="field_item_box">
          <div class="field_item">
            <div class="field_title">姓名：</div>
            <Input maxlength="11" v-model="update_affiliation_data.neitui_name" placeholder="请输入(必填)"
              style="width: 130px" />
          </div>
          <div class="field_item">
            <div class="field_title">身份证号：</div>
            <Input maxlength="18" v-model="update_affiliation_data.neitui_idcard" placeholder="请输入身份证号(选填)"
              style="width: 200px" />
          </div>
        </div>
        <div class="field_item_box">
          <div class="field_item">
            <div class="field_title">手机号：</div>
            <Input maxlength="11" v-model="update_affiliation_data.neitui_phone" placeholder="请输入手机号(必填)"
              style="width: 130px" />
          </div>
        </div>
      </div>

      <div class="field_item_box" v-if="update_affiliation_data.belong_type == 'B03'">
        <div class="field_item">
          <div class="field_title">代理名称：</div>
          <Select size="small" filterable clearable placeholder="请搜索或选择代理用户" v-model="update_affiliation_data.belong_id"
            style="width: 450px">
            <Option v-for="(item, i) in agency_user_list" :value="item.value" :key="i">{{
              item.label
            }}</Option>
          </Select>
        </div>
      </div>

      <div class="add_resume_button_opertion">
        <Button type="primary" @click="update_belong">
          <Icon type="md-add" /> 确认
        </Button>
      </div>
    </Modal>

    <Modal v-model="update_entry_time_show" title="更新入职日期" :footer-hide="true" width="240">
      <DatePicker type="date" placeholder="Select date" style="width: 200px" v-model='update_entry_time_txt' />
      <div class="add_resume_button_opertion">
        <span @click="entry_time_now" class="entry_time_now">当前日期</span>
        <Button type="primary" @click="update_entry_time_confirm">
          <Icon type="md-add" /> 确认更新
        </Button>
      </div>

    </Modal>

    <Modal v-model="update_dimission_time_show" title="更新离职日期" :footer-hide="true" width="240">
      <DatePicker type="date" placeholder="Select date" style="width: 200px" v-model='update_dimission_time_txt' />
      <div class="add_resume_button_opertion">
        <span @click="dimission_time_now" class="entry_time_now">当前日期</span>

        <Button type="primary" @click="update_dimission_time_confirm">
          <Icon type="md-add" /> 确认更新
        </Button>
      </div>

    </Modal>

    <resume_detail ref="resume_detail"></resume_detail>
    <staff_bankcard ref="staff_bankcard"></staff_bankcard>
    <update_idcard @change="update_idcard_change" ref="update_idcard"></update_idcard>

  </div>
</template>

<script>
import QRCode from "qrcodejs2";
import my_menu2 from "@/component/menu/menu2.vue";
import { http, open_new_page } from "@/utils/http.js";
import update_job_name from "@/views/workbench/my_project/roster/update_job_name.vue";
import staff_bankcard from "./component/staff_bankcard.vue";
import resume_detail from "./component/resume_detail.vue";
import update_idcard from "./component/update_idcard2.vue";


export default {
  components: {
    my_menu2,
    update_job_name,
    staff_bankcard,
    update_idcard,
    resume_detail
  },
  data() {
    return {
      windowWidth: document.documentElement.clientWidth, //实时屏幕宽度
      windowHeight: document.documentElement.clientHeight, //实时屏幕高度
      menu_show: true,
      project_id: "",
      job_status: "daiqueren",
      project_name: "",
      columns: [],
      table_data: [],
      page: 1,
      limit: 20,
      total_count: 0,
      tabs_index: "0",
      add_show: false,
      add_type: "input",
      add_item: {
        name: "",
        idcard: "",
        phone: "",
      },
      to_zaizhi_show: false,
      select_data: [],
      entry_date: new Date(),

      to_lizhi_show: false,
      dimission_date: new Date(),
      import_template_url: "",
      upload_file_url:
        process.env.VUE_APP_HOST +
        "/roster_manage/duanqi_detail/upload_xls?token=" +
        this.$cookies.get("dx_token"),
      upload_xls_object_name: "",
      contract_dict: {},
      total_contract_dict: {},
      contract_modal_show: false,
      current_item: {},
      insurance_count_dict: {},
      insurance_show: false,
      baoan_show: false,

      update_affiliation_show: false,
      update_affiliation_project_id: "",
      update_affiliation_interview_id: "",
      update_affiliation_data: {
        belong_type: "B01",
        belong_id: '',

        neitui_name: "",
        neitui_phone: '',
        neitui_idcard: '',

      },
      belong_type_list: [],
      sys_user_list: [],
      agency_user_list: [],


      update_phone_show: false,
      update_phone_value: '',
      update_phone_item: {},
      error_list: [],
      daoru_error_show: false,
      daoru_loading: false,
      search_value: "",
      search_key: "name",
      export_roster_loading: false,
      batch_delete_loading: false,
      update_entry_time_show: false,
      update_entry_time_item: {},
      update_entry_time_txt: "",
      loading: false,

      update_dimission_time_show: false,
      update_dimission_time_item: {},
      update_dimission_time_txt: "",


    };
  },
  mounted() {
    window.onresize = () => {
      var that = this
      return (() => {
        window.fullHeight = document.documentElement.clientHeight;
        window.fullWidth = document.documentElement.clientWidth;
        that.windowHeight = window.fullHeight; // 高
        that.windowWidth = window.fullWidth; // 宽
        console.log("宽高变化", that.windowHeight, that.windowWidth);
      })();
    };

    var query = this.$route.query;
    console.log(this.$route);
    this.job_status = query.job_status;
    this.project_id = query.project_id;
    this.get_table_data();
    this.get_project_info();
    this.get_import_template();
    this.get_belong_type()
    this.get_dx_sys_user()
    this.get_dx_agency_user()

  },
  methods: {

    entry_time_now() {
      const today = new Date().toISOString().slice(0, 10)
      this.update_entry_time_txt = today
    },

    dimission_time_now() {
      const today = new Date().toISOString().slice(0, 10)
      this.update_dimission_time_txt = today
    },

    update_dimission_time_confirm() {
      var that = this;
      var obj = {
        project_id: this.project_id,
        dimission_time: new Date(this.update_dimission_time_txt).getTime() / 1000,
        interview_id: this.update_dimission_time_item['interview_id']
      };
      console.log(obj)
      http(
        "post",
        process.env.VUE_APP_HOST + "/roster_manage/duanqi_detail/dimission_time_update",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.$Message.success({
              content: res.msg,
              duration: 3,
            });
            that.update_dimission_time_show = false
            that.get_table_data();
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    click_update_disimmion_time(e) {
      this.update_dimission_time_item = e
      this.update_dimission_time_txt = e.dimission_time;
      this.update_dimission_time_show = true
    },

    click_update_entry_time(e) {
      this.update_entry_time_item = e
      this.update_entry_time_txt = e.entry_time;
      this.update_entry_time_show = true
    },
    update_entry_time_confirm() {
      var that = this;
      var obj = {
        project_id: this.project_id,
        entry_time: new Date(this.update_entry_time_txt).getTime() / 1000,
        interview_id: this.update_entry_time_item['interview_id']
      };
      console.log(obj)
      http(
        "post",
        process.env.VUE_APP_HOST + "/roster_manage/duanqi_detail/entry_time_update",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.$Message.success({
              content: res.msg,
              duration: 3,
            });
            that.update_entry_time_show = false
            that.get_table_data();
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    export_roster() {
      this.export_roster_loading = true
      console.log('导出花名册')
      let that = this;
      var obj = {
        project_id: this.project_id,
      };
      http(
        "post",
        process.env.VUE_APP_HOST + "/roster_manage/duanqi_detail/export_roster",
        obj,
        true
      )
        .then((res) => {
          this.export_roster_loading = false
          if (res.code == 0) {
            console.log(res.data)
            this.$Modal.confirm({
              title: '导出短期工',
              content: '<p>导出成功，是否下载？</p>',
              onOk: () => {
                open_new_page(res.data.url)
              },
              onCancel: () => {
              }
            });
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    search_btn() {
      this.page = 1
      this.get_table_data();
    },

    //批量删除
    batch_delete() {
      var that = this;
      if (this.select_data.length == 0) {
        this.$Message.error("请至少选择一名");
        return;
      }
      var interview_id_list = [];
      for (var i = 0; i < this.select_data.length; i++) {
        interview_id_list.push(this.select_data[i]["interview_id"]);
      }
      this.$Modal.confirm({
        title: "批量删除",
        content: "<p>确认删除已选中的 " + interview_id_list.length + " 名员工吗？删除后不可恢复。</p>",
        onOk: () => {
          that.batch_delete_request(interview_id_list);
        },
        onCancel: () => { },
      });
    },

    batch_delete_request(interview_id_list) {
      var that = this;
      var obj = {
        project_id: this.project_id,
        interview_id_list: interview_id_list,
      };
      this.batch_delete_loading = true;
      http(
        "post",
        process.env.VUE_APP_HOST + "/roster_manage/duanqi_detail/duanqi_del",
        obj,
        true
      )
        .then((res) => {
          that.batch_delete_loading = false;
          if (res.code == 0) {
            that.$Message.success({
              content: res.msg,
              duration: 3,
            });
            that.select_data = [];
            that.get_table_data();
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          that.batch_delete_loading = false;
          console.log(res, "请求出错");
        });
    },


    update_phone() {
      var that = this;
      var obj = {
        phone: this.update_phone_value,
        resume_id: this.update_phone_item.resume_id,
      };
      http(
        "post",
        process.env.VUE_APP_HOST + "/my_project/daimianshi/update_phone",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.$Message.success({
              content: res.msg,
              duration: 3,
            });
            that.update_phone_show = false;
            that.get_table_data();
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    click_update_phone(roster_item) {
      console.log(roster_item)
      this.update_phone_item = roster_item;
      this.update_phone_value = roster_item['phone'];
      this.update_phone_show = true;
    },

    update_idcard_change() {
      console.log('更新身份证回调')
      this.get_table_data();
    },

    limit_change(e) {
      this.limit = e;
      this.page = 1
      this.get_table_data();
      console.log(e)
    },

    page_change(e) {
      this.page = e
      this.get_table_data();
    },

    //点击更新实名
    click_update_certification(item) {
      var resume_id = item.resume_id;
      var that = this;
      this.$Modal.confirm({
        title: "实名检测",
        content: "<p>确认要对姓名跟身份证进行实名校验吗?" + "</p>",
        onOk: () => {
          that.update_certification_request(resume_id);
        },
        onCancel: () => { },
      });
    },

    update_certification_request(resume_id) {
      var that = this;
      var obj = {
        resume_id: resume_id,
      };
      http(
        "post",
        process.env.VUE_APP_HOST + "/roster_manage/detail/certification",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.$Message.success({
              content: res.msg,
              duration: 3,
            });
            that.get_table_data();
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    //代理系统列表
    get_dx_agency_user() {
      var that = this;
      var obj = {};
      http(
        "post",
        process.env.VUE_APP_HOST + "/my_project/daimianshi/dx_agency_user",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.agency_user_list = res.data.user_list;
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    // 更新归属人
    update_belong() {
      var that = this;
      var obj = {
        'project_id': this.update_affiliation_project_id,
        'interview_id': this.update_affiliation_interview_id,
        'belong_type': this.update_affiliation_data.belong_type,
        'belong_id': this.update_affiliation_data.belong_id,

        neitui_phone: this.update_affiliation_data.neitui_phone,
        neitui_name: this.update_affiliation_data.neitui_name,
        neitui_idcard: this.update_affiliation_data.neitui_idcard,

      };
      http(
        "post",
        process.env.VUE_APP_HOST + "/roster_manage/duanqi_detail/update_belong",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.$Message.success({
              content: res.msg,
              duration: 3,
            });
            that.update_affiliation_show = false
            this.get_table_data();

          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },
    //系统用户列表
    get_dx_sys_user() {
      var that = this;
      var obj = {};
      http(
        "post",
        process.env.VUE_APP_HOST + "/my_project/daimianshi/dx_sys_user",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.sys_user_list = res.data.user_list;
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    //归属人类型
    get_belong_type() {
      var that = this;
      var obj = {};
      http(
        "post",
        process.env.VUE_APP_HOST + "/roster_manage/duanqi_detail/belong_type",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.belong_type_list = res.data.type_list;
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },
    belong_type_change(e) {
      console.log(e)
      // if(e=='B02'){
      //   this.update_affiliation_data.belong_name = ''
      //   this.update_affiliation_data.belong_id = ''
      //   this.update_affiliation_data.neitui_phone = ''
      // }
    },
    click_update_belong(row) {
      console.log(row)


      this.update_affiliation_project_id = row.project_id
      this.update_affiliation_interview_id = row.interview_id
      this.update_affiliation_data.belong_type = row.belong_type
      this.update_affiliation_data.belong_id = row.belong_id;


      if (row.belong_type_status == "B01") {
        this.update_affiliation_data.belong_id = row.belong_id;
      }
      if (row.belong_type_status == "B02") {
        console.log("归属人-------");
        this.update_affiliation_data.belong_name = row.belong_name;
        this.update_affiliation_data.belong_id = row.belong_phone;
        this.update_affiliation_data.neitui_phone = row.neitui_phone;
      }
      if (row.belong_type_status == "B03") {
        this.update_affiliation_data.belong_id = row.belong_id;
      }

      this.get_belong_type()
      this.get_dx_agency_user();
      this.get_dx_sys_user()
      this.update_affiliation_show = true
    },

    gongshang_baoan_jiaocheng() {
      var url = "https://alidocs.dingtalk.com/i/p/7xZBGL2jAMMXL1wvrqGd9Mr2dYr33zaV";
      open_new_page(url);
    },
    gongshang_baoan_record() {
      var project_id = this.project_id;

      var url =
        "https://insurance.daxiangsys.com/compenset/beian/record?project_id=" +
        project_id;
      // var url =
      // "http://127.0.0.1:8007/compenset/beian/record?project_id=" +
      // project_id;
      open_new_page(url);
    },

    //新报案
    new_gongshang_baoan() {
      var that = this;
      var interview_id_list = [];
      for (let i = 0; i < this.select_data.length; i++) {
        interview_id_list.push(this.select_data[i]["interview_id"]);
      }

      if (this.select_data.length == 0) {
        this.$Message.error("至少选择一位");
        return;
      }
      if (this.select_data.length > 1) {
        this.$Message.error("最多选择一位");
        return;
      }

      var resume_id = this.select_data[0].resume_id;
      var project_id = that.project_id;
      var url =
        "https://insurance.daxiangsys.com/compenset/beian/create?resume_id=" +
        resume_id +
        "&project_id=" +
        project_id;

      open_new_page(url);
    },

    gongshang_baoan() {
      this.baoan_show = true;
    },
    update_job_name_change() {
      this.get_table_data();
    },

    click_job(row) {
      // 更新岗位
      this.$refs.update_job_name.open(this.project_id, row);
    },

    //批量参保
    batch_insured() {
      var that = this;
      var resume_id_list = [];
      for (let i = 0; i < this.select_data.length; i++) {
        resume_id_list.push(this.select_data[i]["resume_id"]);
      }

      if (this.select_data.length == 0) {
        this.$Message.error("至少选择一位");
        return;
      }

      var _dict = {
        resume_id_list: resume_id_list,
        project_id: that.project_id,
      };

      http(
        "post",
        process.env.VUE_APP_HOST + "/roster_manage/detail/batch_insurance",
        _dict,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            var url = res.data.url;
            open_new_page(url);
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    //点击查看保险详情
    click_insurance_list() {
      var that = this;
      console.log(this.current_item);

      var obj = {
        project_id: that.project_id,
        resume_id: this.current_item.resume_id,
      };
      http(
        "post",
        process.env.VUE_APP_HOST + "/roster_manage/detail/join_insurance",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            // that.$Message.success({
            //     content: res.msg,
            //     duration: 3,
            // });
            var url = res.data.url;
            open_new_page(url);
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    click_contract_list() {
      var that = this;
      console.log(this.current_item);

      var obj = {
        project_id: that.project_id,
        idcard: this.current_item.idcard,
      };
      http(
        "post",
        process.env.VUE_APP_HOST + "/roster_manage/detail/contract_list",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            // that.$Message.success({
            //     content: res.msg,
            //     duration: 3,
            // });
            var url = res.data.sign_url;
            open_new_page(url);
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },
    click_sing_contract(status) {
      var item = this.current_item;
      console.log(item, status);
      var that = this;

      var obj = {
        project_id: that.project_id,
        resume_id: item.resume_id,
        status: status,
        interview_status: "短期工",
        interview_id: item.interview_id,
      };
      http(
        "post",
        process.env.VUE_APP_HOST + "/roster_manage/detail/sign_contract",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.$Message.success({
              content: res.msg,
              duration: 3,
            });
            var url = res.data.sign_url;
            open_new_page(url);
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },
    //获取合同数据
    get_contract_data() {
      var that = this;
      var table_data = JSON.parse(JSON.stringify(this.table_data));
      var idcard_list = [];
      for (let i = 0; i < table_data.length; i++) {
        idcard_list.push(table_data[i]["idcard"]);
      }
      var obj = {
        idcard_list: idcard_list,
        project_id: this.project_id,
      };
      http(
        "post",
        process.env.VUE_APP_HOST + "/roster_manage/detail/roster_contract",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.contract_dict = res.data.contract_dict;
            that.total_contract_dict = res.data.total_contract_dict;
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    import_confirm() {
      var that = this;
      var obj = {
        object_name: this.upload_xls_object_name,
        project_id: this.project_id,
      };
      that.daoru_loading = true
      http(
        "post",
        process.env.VUE_APP_HOST + "/roster_manage/duanqi_detail/import_duanqigong",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.daoru_loading = false
            that.$Message.success({
              content: res.msg,
              duration: 3,
            });
            if (res.data.error_list.length > 0) {
              that.error_list = res.data.error_list
              that.daoru_error_show = true
            }
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    upload_success(e) {
      console.log(e);
      if (e.code == 0) {
        this.$Message.success(e.msg);
        this.upload_xls_object_name = e.data.object_name;
      } else {
        this.$Message.error(e.msg);
        this.$refs.upload.clearFiles();
      }
    },
    get_import_template() {
      var that = this;
      var obj = {};
      http(
        "post",
        process.env.VUE_APP_HOST + "/my_project/daimianshi/import_template",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.import_template_url = res.data.dqg_url;
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },
    to_lizhi() {
      this.to_lizhi_show = true;
    },

    to_lizhi_request() {
      var that = this;
      var intervew_id_list = [];
      for (var i = 0; i < this.select_data.length; i++) {
        intervew_id_list.push(this.select_data[i]["interview_id"]);
      }
      console.log(intervew_id_list);
      var dimission_time = Number(this.entry_date.getTime() / 1000);

      var obj = {
        project_id: this.project_id,
        intervew_id_list: intervew_id_list,
        dimission_time: dimission_time,
      };
      http(
        "post",
        process.env.VUE_APP_HOST + "/roster_manage/duanqi_detail/to_lizhi",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.$Message.success({
              content: res.msg,
              duration: 3,
            });
            that.get_table_data();
            that.to_lizhi_show = false;
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    select_change(e) {
      this.select_data = e;
    },
    add_new_staff() {
      console.log("添加新面试");
      this.add_show = true;
      this.get_wxmp_qrcode();
    },

    get_wxmp_qrcode() {
      var that = this;
      var obj = {
        project_id: this.project_id,
      };
      http(
        "post",
        process.env.VUE_APP_HOST + "/roster_manage/duanqi_detail/duanqigong_wxmp_qrcode",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.$refs.qrCodeUrl.innerHTML = "";
            that.scan_time = 0;
            var qrcode = new QRCode(that.$refs.qrCodeUrl, {
              text: res.data.url, // 需要转换为二维码的内容
              width: 149,
              height: 148,
              colorDark: "#000000",
              colorLight: "#ffffff",
              correctLevel: QRCode.CorrectLevel.H,
            });
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    input_add_request() {
      var that = this;
      var obj = {
        project_id: this.project_id,
        name: this.add_item.name,
        idcard: this.add_item.idcard,
        phone: this.add_item.phone,
      };
      http(
        "post",
        process.env.VUE_APP_HOST + "/roster_manage/duanqi_detail/add_staff",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.$Message.success({
              content: res.msg,
              duration: 3,
            });
            that.get_table_data();
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    to_zaizhi() {
      if (this.select_data.length == 0) {
        this.$Message.error("请至少选择一名");
        return;
      }

      this.to_zaizhi_show = true;
    },

    to_zaizhi_request() {
      var that = this;
      var intervew_id_list = [];
      console.log(this.select_data);
      for (var i = 0; i < this.select_data.length; i++) {
        intervew_id_list.push(this.select_data[i]["interview_id"]);
      }
      console.log(intervew_id_list);
      var entry_time = Number(this.entry_date.getTime() / 1000);

      var obj = {
        project_id: this.project_id,
        intervew_id_list: intervew_id_list,
        entry_time: entry_time,
      };
      http(
        "post",
        process.env.VUE_APP_HOST + "/roster_manage/duanqi_detail/to_zaizhi",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.$Message.success({
              content: res.msg,
              duration: 3,
            });
            that.get_table_data();
            that.to_zaizhi_show = false;
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    click_tabs(e) {
      console.log(this.job_status);
      this.get_table_data();
    },

    click_insurance(item) {
      this.current_item = JSON.parse(JSON.stringify(item));
      this.insurance_show = true;
    },

    get_table_data() {
      var that = this;
      var obj = {
        project_id: this.project_id,
        page: this.page,
        limit: this.limit,
        job_status: this.job_status,
        search_key: this.search_key,
        'search_value': this.search_value
      };
      this.loading = true
      http(
        "post",
        process.env.VUE_APP_HOST + "/roster_manage/duanqi_detail/duanqi_table_data",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.columns = res.data.columns;
            that.table_data = res.data.data_list;
            that.total_count = res.data.total_count


            that.get_contract_data();
            that.get_insurance_data();
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
          that.loading = false
        })
        .catch((res) => {
          console.log(res, "请求出错");
          that.loading = false
        });
    },

    click_contract(item) {
      this.current_item = item;
      this.contract_modal_show = true;
    },

    //获取保险数据
    get_insurance_data() {
      var that = this;
      var table_data = JSON.parse(JSON.stringify(this.table_data));
      var idcard_list = [];
      for (let i = 0; i < table_data.length; i++) {
        idcard_list.push(table_data[i]["idcard"]);
      }
      var obj = {
        idcard_list: idcard_list,
      };
      http(
        "post",
        process.env.VUE_APP_HOST + "/roster_manage/detail/roster_insurance",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.insurance_count_dict = res.data.count_dict;
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    click_name(item) {
      this.$refs.resume_detail.open(item, this.project_id);
    },

    get_project_info() {
      var that = this;
      var obj = {
        project_id: this.project_id,
      };
      http(
        "post",
        process.env.VUE_APP_HOST + "/roster_manage/duanqi_detail/project_info",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.menu_show = false;
            setTimeout(function () {
              that.menu_show = true;
            }, 50);

            that.project_name = res.data.project_name;
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    click_contract(item) {
      this.current_item = item;
      this.contract_modal_show = true;
    },
    //点击员工银行卡
    click_resume_bank_card(row) {
      this.$refs.staff_bankcard.open(row.resume_id);
    },
    //点击身份证号
    click_idcard_num(item) {
      this.$refs.update_idcard.open(item);
    },

  },
};
</script>

<style scoped>
.entry_time_now {
  color: #747474;
  cursor: pointer;
  padding-right:40px;
}

.daoru_line_div {
  height: 500px;
  overflow: auto;
}

.daoru_line {
  font-size: 13px;
  border-bottom: 1px solid #ececec;
  padding: 5px;
}

.update_phone_button {
  display: flex;
  margin-top: 10px;
  justify-content: end;
}

.idcard_span_div {
  display: flex;
  align-items: center;
}


.sfz_icon1 {
  cursor: pointer;
  font-size: 14px;
  color: #01b729;
  margin-left: 2px;
}

.sfz_icon2 {
  cursor: pointer;
  font-size: 14px;
  color: #fb0000;
  margin-left: 2px;
}

.iconweirenzheng {
  font-size: 12px;
  color: #fb0000;
  margin-left: 3px;
  cursor: pointer;
}

.iconrenzheng {
  font-size: 10px;
  color: #01b729;
  margin-left: 3px;
  cursor: pointer;
}

.idcard_num {
  cursor: pointer;
  color: #0466dd;
}

.name {
  color: #0466dd;
  cursor: pointer;
}

.bank_card_hover:hover {
  opacity: .6;
}

.bank_card1 {
  color: #fff;
  background-color: #0466dd;
  padding: 3px 5px;
  border-radius: 5px;
  cursor: pointer;
}

.bank_card2 {
  color: #fff;
  background-color: #f0022e;
  padding: 3px 5px;
  border-radius: 5px;
  cursor: pointer;
}

.add_resume_button_opertion {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding-top: 20px;
}


.field_title {
  width: 100px;
  flex-shrink: 0;
}

.field_title2 {
  width: 70px;
  flex-shrink: 0;
}

.field_item {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  margin-right: 20px;
}

.field_item_box {
  display: flex;
  width: 800px;
  padding-left: 10px;
}

.job {
  cursor: pointer;
  color: #0466dd;
}

.roster_name:hover {
  color: #00aeff;
}

.contract_button_class {
  text-align: left;
  width: 120px;
  font-size: 13px;
  margin-right: 10px;
}

.contract_button_class2 {
  margin-top: 10px;
  text-align: left;
  width: 120px;
  font-size: 13px;
  margin-right: 10px;
}

.contract_button_class3 {
  margin-top: 10px;
  text-align: left;
  width: 120px;
  font-size: 13px;
  margin-right: 10px;
}

.contract_span {
  color: #0466dd;
  cursor: pointer;
}

.contract_span:hover {
  color: #0173ff;
  font-weight: 600;
}

.contract_span2 {
  color: #0466dd;
  cursor: pointer;
  margin-left: 10px;
}

.contract_span2:hover {
  color: #0173ff;
  font-weight: 600;
}

.ruzhi_button {
  display: flex;
  margin-top: 40px;
  justify-content: flex-end;
}

.entry_date_title {
  width: 120px;
  flex-shrink: 0;
}

.entry_date_box {
  display: flex;
  align-items: center;
}

.qrcode_img_title {
  margin-top: 10px;
}

.qrcode_img_div {
  display: flex;
  padding: 30px;
  justify-content: center;
}

.qrcode_img {
  width: 150px;
  height: 150px;
  text-align: center;
  border: 1px solid #ccc;
}

.input_1 {}

.input_button_div {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-top: 10px;
}

.input_title {
  width: 100px;
  flex-shrink: 0;
}

.input_div {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.search_group {
  display: flex;
  align-items: center;
}

.search_group .search_select {
  width: 80px;
  flex-shrink: 0;
}

.search_group /deep/ .search_select .ivu-select-selection {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border-right: none;
}

.search_group .search_input {
  width: 130px;
  flex-shrink: 0;
}

.search_group /deep/ .search_input .ivu-input {
  border-radius: 0;
}

.search_group .search_btn {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  margin-left: -1px;
}

.options {
  display: flex;
  justify-content: space-between;
  padding: 0 10px 0px 10px;
  position: relative;
  top: -10px;
}

.page_div {
  display: flex;
  margin-top: 5px;
  justify-content: center;
}

.table_div {
  padding: 0 10px 10px 10px;
  height: calc(100vh - 150px);
  position: relative;
}

.tabs_div {
  display: flex;
  justify-content: center;
}
</style>
